<template>
  <div class="admin-datatable">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Płatności</v-toolbar-title>
    </v-toolbar>
    </v-card>
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-form class="flex">
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-select
                  v-model="context.paymentStatus"
                  :items="[{value: 'paid', text: 'Opłacone'}, {value: 'unpaid', text: 'Nieopłacone'}, {value: 'exceeded', text: 'Przekroczono termin'}]"
                  label="Status płatności"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  :return-value.sync="context.start"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="context.start"
                    label="Data od"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="context.start" type="month" @input="$refs.menu1.save(context.start)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  :return-value.sync="context.end"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="context.end"
                    label="Data do"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="context.end" type="month" @input="$refs.menu2.save(context.end)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>

            </v-layout>
          </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="payments"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
          <td>
            {{props.item.period | formatDate('MMMM YYYY')}}
          </td>
          <td v-if="!isTrainer">{{ props.item.price}}</td>
          <td>
            <runner-payment-status :status="props.item.payment_status" :id="props.item.id" :runner_id="runner.id" @change="refresh"></runner-payment-status>
          </td>
          <td v-if="!isTrainer">
            {{props.item.due_date | formatDate('YYYY-MM-DD')}}
          </td>
          <td v-if="!isTrainer">
            <a v-if="props.item.document_url" :href="props.item.document_url">
              {{props.item.document_filename}}</a>
          </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {fetchRunnerPayments} from './api'
import {ListMixin} from '@/utils/ListMixin'
import iziToast from 'izitoast'
import { mapState, mapGetters } from 'vuex'
import RunnerPaymentStatus from './RunnerPaymentStatus'
import _ from 'lodash'

export default {
  name: 'payments',
  components: {RunnerPaymentStatus},
  mixins: [ListMixin],
  data () {
    return {
      context: {rowsPerPage: 10, sortBy: 'period', descending: true},
      menu1: false,
      menu2: false,
      loading: true,
      payments: []
    }
  },
  created () {
    if (this.$route.query.status) {
      if (this.$route.query.status === 'success') {
        iziToast.show({
          message: 'Płatność została zrealizowana',
          color: 'green'
        })
      } else {
        iziToast.show({
          message: 'Płatność nie mogła zostać zrealizowana',
          color: 'red'
        })
      }
    }
  },
  watch: {
    context: {
      handler () {
        this.getPayments()
      },
      deep: true
    },
    '$route': 'getPayments'
  },
  computed: {
    headers () {
      if (this.isTrainer) {
        return [
          {
            value: 'period',
            text: 'okres',
            sortable: true
          },
          {
            value: 'payment_status',
            text: 'status',
            sortable: false
          }
        ]
      } else {
        return [
          {
            value: 'period',
            text: 'okres',
            sortable: true
          },
          {
            value: 'price',
            text: 'cena',
            sortable: true
          },
          {
            value: 'payment_status',
            text: 'status',
            sortable: false
          },
          {
            value: 'due_date',
            text: 'termin płatności',
            sortable: false
          },
          {
            value: 'document',
            text: 'rachunki',
            sortable: false
          }
        ]
      }
    },
    ...mapState(['runner']),
    ...mapGetters(['isActiveRunner', 'isTrainer'])
  },
  methods: {
    getPayments () {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.end !== null) {
        params['period__lte'] = this.context.end
      }
      if (this.context.start !== null) {
        params['period__gte'] = this.context.start
      }
      if (this.context.paymentStatus !== null) {
        params['payment_status'] = this.context.paymentStatus
      }
      let promise = fetchRunnerPayments(this.runner, params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.payments = data
        return data
      })
    },
    refresh: _.debounce(function () {
      this.getPayments()
    }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// src/payments/RunnerPayments.vue